<script>
import Layout from '@layouts/guest.vue'
import { authComputed, authMethods } from '@state/helpers'
import ForgotPassword from '@guest/components/forgot-password.vue'

export default {
  page: {
    meta: [{ name: 'description', content: `Log in to PENCIL` }],
  },
  components: { Layout, ForgotPassword },
  data() {
    return {
      email: '',
      forgotPasswordError: '',
      tryingToLogIn: false,
    }
  },
  computed: { ...authComputed },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    postForgotPassword(params) {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.forgotPasswordError = ''
      return this.forgotPassword({
        email: params.email,
      }).then((response) => {
        if (response.message) {
          this.forgotPasswordError = 'non_existing_user'
        } else {
        }
      })
    },
    clearForgotPasswordErrors() {
      this.forgotPasswordError = ''
    },
  },
}
</script>

<template>
  <Layout>
    <ForgotPassword
      :trying-to-login="tryingToLogIn"
      :forgot-password-error="forgotPasswordError"
      :is-trying-to-login="isTryingToLogin"
      @post-forgot-password="postForgotPassword"
      @clear-forgot-password-errors="clearForgotPasswordErrors"
    ></ForgotPassword>
  </Layout>
</template>
